import { DishContentHighlightedText, DishContents, DishContentsText, Seperator } from "../../components/DishContents";
import { isEmptyObject } from "../objects";

interface RenderDishContentProps {
	dishData: any;
	allergens?: any;
	dietaryPreferences?: any;
	ignoreDietaryPreferences?: boolean;
}

type IngredientElementProps = {
	ingredientString: string;
	isAllergic: boolean;
};

const IngredientElement: React.FC<IngredientElementProps> = ({ ingredientString, isAllergic }) => {
	return isAllergic ? (
		<DishContentHighlightedText>{ingredientString}</DishContentHighlightedText>
	) : (
		<DishContentsText>{ingredientString}</DishContentsText>
	);
};

function renderIngredientElements(segments: any, allergicIngredients: any) {
	let ingredientElements: any[] = [],
		alreadyAddedIngredients = new Set<string>([]);

	for (const segmentId in segments) {
		const segmentData = segments?.[segmentId];
		if (!segmentData?.ingredients) continue;
		for (const ingredientId in segmentData.ingredients) {
			const ingredientSegmentData = segmentData.ingredients[ingredientId];
			const isAllergicToUser = allergicIngredients.has(ingredientId);
			let ingredientString: string = "";

			if (alreadyAddedIngredients.has(ingredientId) || !ingredientSegmentData?.name) continue;

			ingredientString = ingredientSegmentData?.name;
			if (ingredientSegmentData.portionSelected > 1) {
				ingredientString += ` ${ingredientSegmentData.portionSelected}x`;
			}

			ingredientElements.push(<IngredientElement key={ingredientId} ingredientString={ingredientString} isAllergic={isAllergicToUser} />);
			ingredientElements.push(<Seperator key={`${ingredientId}-seperator`} >. </Seperator>);
			alreadyAddedIngredients.add(ingredientId);
		}
	}
	return ingredientElements;
}

export function renderDishContents({
	dishData,
	allergens,
	dietaryPreferences,
	ignoreDietaryPreferences = false,
}: RenderDishContentProps): any {
	if (isEmptyObject(dishData.segments)) return;

	let allergicIngredients = new Set<string>([]);

	if (allergens) {
		for (const allergy in allergens) {
			if (!ignoreDietaryPreferences && dietaryPreferences) {
				if (!dietaryPreferences.includes(allergy)) continue;
			}

			for (const ingredient of allergens[allergy]) {
				allergicIngredients.add(ingredient.ingredientId);
			}
		}
	}

	const ingredientElements = renderIngredientElements(dishData.segments, allergicIngredients);
	return <DishContents>{ingredientElements}</DishContents>;
}
